import { createSelector } from '@reduxjs/toolkit'
import moment from 'moment'
import { pathOr } from 'ramda'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'
import { MigrationReducer } from './model'
import { customMigrationKey, defaultState } from './reducers'

const dateFormat = 'ddd D MMM h:mm A'

export const migrationsSelector = createSelector(
  (state) => pathOr<MigrationReducer>(defaultState, [customMigrationKey])(state),
  (result) => result,
)

export const vmMigrationsSelector = createSharedSelector(
  getDataSelector<DataKeys.VmMigrations>(DataKeys.VmMigrations),
  (migrations) => {
    return migrations
      .filter((migration) => ['migration', 'live-migration'].includes(migration?.migration_type))
      .map((migration) => {
        const createdTimestamp = `${migration?.created_at?.split('.')?.[0]}Z`
        const updatedTimestamp = `${migration?.updated_at?.split('.')?.[0]}Z`
        // any model changes go here
        return {
          createdTimestamp,
          updatedTimestamp,
          createdTimeString: moment(createdTimestamp).format(dateFormat),
          updatedTimeString: moment(updatedTimestamp).format(dateFormat),
          ...migration,
        }
      })
  },
)

export const latestMigrationByVmSelector = createSharedSelector(
  vmMigrationsSelector,
  (migrations) => {
    const migrationsByVmId = migrations.reduce((accum, migration) => {
      // Only want latest a VM's latest migration
      if (
        accum[migration?.instance_uuid] &&
        accum[migration?.instance_uuid].createdTimestamp > migration?.createdTimestamp
      ) {
        return accum
      }
      return {
        ...accum,
        [migration?.instance_uuid]: migration,
      }
    }, {})
    return migrationsByVmId
  },
)
